const footerItems = [
	{
		id: "1",
		text: "Δήλωση προσβασιμότητας",
		href: "https://www.gov.gr/info/dilosi-prosvasimotitas",
	},
	{
		id: "2",
		text: "Όροι χρήσης",
		href: "https://www.gov.gr/info/oroi-xrisis",
	},
	{
		id: "3",
		text: "Ιδιωτικό απόρρητο",
		href: "https://www.gov.gr/info/politiki-aporritou",
	},
	// {
	//   id: "4",
	//   text: "Επικοινωνία",
	//   href: "/contact",
	// },
	// {
	//   id: "5",
	//   text: "Χρήσιμα έγγραφα",
	//   href: "/help/docs",
	// },
];

function Footer() {
	return (
		<footer className="footer p-3 mt-auto">
			<div className="container">
				<div className="row">
					<div className="col-md-7">
						<ul className="list-inline">
							{footerItems.map((item) => (
								<li className="list-inline-item" key={item.id}>
									<a href={item.href}>{item.text}</a>
								</li>
							))}
						</ul>
						<p>
							© Copyright 2026 -  Υπουργείο Ψηφιακής Διακυβέρνησης
						</p>
					</div>
					<div className="text-start d-flex align-items-center gap-3 text-lg-end col-md-4">
						<a
							className="footer-logo-link"
							href="https://mindigital.gr/"
							target="_blank"
							rel="noopener noreferrer"
							title="Υπουργείο Ψηφιακής Διακυβέρνησης (ανοίγει σε νέα καρτέλα)"
						>
							<img src="/img/logo-blue.svg" width="260" alt="" />
							<span className="visually-hidden">
								Υπουργείο Ψηφιακής Διακυβέρνησης (ανοίγει σε νέα καρτέλα)
							</span>
						</a>
						<a
							className="footer-logo-link"
							href="https://www.minedu.gov.gr/"
							target="_blank"
							rel="noopener noreferrer"
							title="Υπουργείο Παιδείας, Θρησκευμάτων και Αθλητισμού (ανοίγει σε νέα καρτέλα)"
						>
							<img src="/img/white.svg" alt="" width="190" />
							<span className="visually-hidden">
								Υπουργείο Παιδείας, Θρησκευμάτων και Αθλητισμού (ανοίγει σε νέα καρτέλα)
							</span>
						</a>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
